import { MARK_COMPLETED_FALLBACK_LABEL } from './agent-autonomy-copy';

/** Join names with a comma list and an Oxford "or": "A", "A or B", "A, B, or C". */
function joinNames(names: string[]): string {
  if (names.length === 1) {
    return names[0];
  }
  if (names.length === 2) {
    return `${names[0]} or ${names[1]}`;
  }
  return `${names.slice(0, -1).join(', ')}, or ${names[names.length - 1]}`;
}

// TODO(copy): final wording is Laura's
/**
 * Format the "mark as completed" action label from a pipeline's terminal
 * stage names. Stage names are customer text and render verbatim — never
 * recased. A pipeline with no terminal stages falls back to "done", the
 * closed state vocabulary's word (Active / Paused / On / Off / Done), so the
 * fallback and a customer-named row read as deliberate siblings rather than
 * a casing mismatch.
 */
export function formatMarkCompletedLabel(terminalNames: string[]): string {
  if (terminalNames.length === 0) {
    return MARK_COMPLETED_FALLBACK_LABEL;
  }
  return `Mark as ${joinNames(terminalNames)}`;
}
